exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#sales-reps[data-v-77121554]{margin-top:80px}.page-title[data-v-77121554]{margin-bottom:20px}.table th[data-v-77121554]{border-top:none}.badge[data-v-77121554]{font-size:.75em}.btn-group .btn[data-v-77121554]{margin-right:2px}.btn-group .btn[data-v-77121554]:last-child{margin-right:0}.clickable-badge[data-v-77121554]{transition:all .2s ease}.clickable-badge[data-v-77121554]:hover{transform:scale(1.05);box-shadow:0 2px 4px rgba(0,0,0,.2)}", ""]);

// exports
